import { tx } from "netbank-shared/src/libs/i18n";
import React, { HTMLAttributes } from "react";
import rootStyles from "~views/pages/Root.scss";

interface NewMessagesBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  value?: number;
}

export const NewMessagesBadge = (props: NewMessagesBadgeProps) => {
  const { value, ...rest } = props;

  if (!value || Number(value) === 0) return null;

  return (
    <span {...rest}>
      {value}
      <span className={rootStyles.screenReaderOnly}>&nbsp;{tx("misc.new_messages")}</span>
    </span>
  );
};
